import Box from "@mui/material/Box"
import styled from "@mui/material/styles/styled"

const FlexBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
})

export const CenteredFlexBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
})

export default FlexBox
